<!-- <section>
    <div>
        <video style="z-index: 0;" id="loginVideo" playsinline  class="videoBg" (ended)="endVideo()">
            <source src="https://d3ep09c8x21fmh.cloudfront.net/sanofi/outer.mp4" type="video/mp4">
        </video>
    </div>
    <div class="reception" (click)="videoplay();" title="Play" >
                    
        <div class="pulsating-circle" id="reception_pulse"></div>
    </div>
    <span id="skip">
        <a class="nav-link sign" (click)="skip()" title="skip" role="button">
            Skip</a>
    </span>
</section> -->


<section class="sectionBgnew">
    <span id="skip" *ngIf="yesSkip">
        <a class="nav-link sign" (click)="skip()" title="skip" role="button">
            Skip</a>
    </span>
    <div class="content-wrap">
        <div class="content loby-content">
            <div [ngStyle]="{'display':videoPlay ? 'none': 'block'}" class="img-fluid">
                <!-- <div class="bg"></div> -->
                <div class="loby-bg">
                    <img src="assets/event/outer.jpg" width="100%" alt="audi" style="height:100vh">
                    <!-- <video src="https://gskamm2021.virtualxp.live/videos/lobby-video.mp4" width="100%" loop autoplay></video> -->
                </div>
                <!-- <h6 class="well" (click)="videoplay();">Click here to enter</h6> -->
                <div class="reception" (click)="videoplay();" title="Play" >
                    
                    <!-- <div class="pulsating-circle" id="reception_pulse"></div> -->
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <div class="container-fluid" [ngStyle]="{'display':videoPlay? 'none': 'block'}">
<img src="../../assets/honeywell/chat.png" (click)="videoplay()" alt="">
</div> -->
<div [ngStyle]="{'display':registrationDesk? 'block': 'none'}" class="videoContainer">
    <video id="loginVideo" playsinline (ended)="endVideo()" style="width: 100%;">
      <source src="https://d3ep09c8x21fmh.cloudfront.net/bpclvideo/outer.mp4" crossorigin="anonymous" type="video/mp4">
    </video>
</div>